import React, { useState, useEffect } from 'react';
import styles from './Text.module.less';

export default props => {
  const {
    className,
    placeholder = '请输入内容',
    maxLen,
    required,
    initText,
    validate = null,
    maxLenTipStyle = null,
    validateInfo = {},
    defaultValue = null,
  } = props;
  const [node, setNode] = useState(null);
  const [nodeLen, setNodeLen] = useState((defaultValue && defaultValue.length) || 0);
  // 验证输入的长短
  const handleSizeAndRequired = content => {
    if (required && !content) {
      return validateInfo.required;
    }
    if (content && maxLen && content.length > maxLen) {
      return validateInfo.size;
    }

    return null;
  };
  useEffect(() => {
    if (node) {
      setNodeLen((defaultValue && defaultValue.length) || 0);
      validate(handleSizeAndRequired(defaultValue));
    }
  }, [node, defaultValue]); // 初始化验证
  const handleText = () => {
    const validateResult = handleSizeAndRequired(node.value);
    // eslint-disable-next-line no-unused-expressions
    validate && validate(validateResult); // 传递验证结果
    setNodeLen((node && node.value && node.value.length) || 0); // 计算现有内容的长度
  };

  useEffect(() => {
    if (initText && node) {
      initText(node);
    }
  }, [node]);

  return (
    <div className={styles.textarea}>
      <input
        className={className || styles.text}
        ref={r => setNode(r)}
        onChange={handleText}
        placeholder={placeholder}
        type="text"
      />
      {(maxLen === 0 || maxLen) && (
        <div className={maxLenTipStyle || styles.textarea_len}>
          <span className={nodeLen > maxLen ? styles.danger_tip : ''}>{nodeLen}</span>/{maxLen}
        </div>
      )}
    </div>
  );
};
